const TEXT_COLOR_TYPE = "wix-rich-content-text-color";
const TEXT_HIGHLIGHT_TYPE = "wix-rich-content-text-highlight";
export {
  TEXT_COLOR_TYPE,
  TEXT_HIGHLIGHT_TYPE
};
//# sourceMappingURL=types.js.map
